import { useMemo, useState } from "react";
import { AlertBanner } from "@spark";
import { getLanguageNameByCode } from "@/shared/constants/languageConstants";

const normalizeLanguageCodes = (codes) => {
  if (!Array.isArray(codes)) return [];
  return codes
    .filter(Boolean)
    .map((c) => String(c).trim())
    .filter((c) => c.length > 0);
};

export default function UnsupportedLanguagesWarning({ unsupportedLanguages }) {
  const [dismissed, setDismissed] = useState(false);
  const normalized = useMemo(
    () => normalizeLanguageCodes(unsupportedLanguages),
    [unsupportedLanguages]
  );

  if (normalized.length === 0 || dismissed) return null;

  const unique = Array.from(new Set(normalized));
  const list = unique.map(code => getLanguageNameByCode(code)).join(", ");

  return (
    <div style={{ marginBottom: 16 }}>
      <AlertBanner
        feedback="warning"
        showIcon
        text={unique.length > 1
          ? `Some languages are not supported for this task: ${list}`
          : `Language ${list} is not supported for this task`}
        showButton={false}
        showCloseButton
        onCloseClick={() => setDismissed(true)}
      />
    </div>
  );
}
